import axios from "axios";
import {
  EDIT_PROFILE_SET_STATE,
  EDIT_PROFILE_UPDATE_FIELD,
  TECH_PROFILE_GET_DATA_BY_USERNAME_FAIL,
  TECH_PROFILE_GET_DATA_BY_USERNAME_REQUEST,
  TECH_PROFILE_GET_DATA_BY_USERNAME_SUCCESS,
  TECH_PROFILE_GET_PREVIOUS_DATA_FAIL,
  TECH_PROFILE_GET_PREVIOUS_DATA_REQUEST,
  TECH_PROFILE_GET_PREVIOUS_DATA_RESET,
  TECH_PROFILE_GET_PREVIOUS_DATA_SUCCESS,
  TECH_PROFILE_LINK_CHANGES,
  TECH_PROFILE_PUBLISH_FAIL,
  TECH_PROFILE_PUBLISH_REQUEST,
  TECH_PROFILE_PUBLISH_SUCCESS,
  TECH_PROFILE_SCROLL_TO_SECTION,
  TECH_PROFILE_USERNAME_CHECK_FAIL,
  TECH_PROFILE_USERNAME_CHECK_REQUEST,
  TECH_PROFILE_USERNAME_CHECK_RESET,
  TECH_PROFILE_USERNAME_CHECK_SUCCESS,
} from "../../constants/MyTechProfile/myTechprofileConstants";
import { APIRequestURI } from "../../utils/api_request_uri";

export const updateProfileField = (field, value) => (dispatch) => {
  dispatch({
    type: EDIT_PROFILE_UPDATE_FIELD,
    payload: { field, value },
  });
};

// Action to set the entire profile state, useful for initializing data
export const setProfileState = (profileData) => (dispatch) => {
  dispatch({
    type: EDIT_PROFILE_SET_STATE,
    payload: profileData,
  });
  sessionStorage.setItem("mytechprofileData", JSON.stringify(profileData));
};

export const scrollToSpecificContentAction =
  (scrollToSection) => (dispatch) => {
    dispatch({
      type: TECH_PROFILE_SCROLL_TO_SECTION,
      payload: scrollToSection,
    });
  };

export const techProfileLinkChangeAction = (linkChangedFor) => (dispatch) => {
  dispatch({
    type: TECH_PROFILE_LINK_CHANGES,
    payload: linkChangedFor,
  });
};

export const publishTechProfileAction =
  (techProfileData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TECH_PROFILE_PUBLISH_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      // Using PUT to update/publish the profile. You could also use POST.
      const { data } = await axios.post(
        `${URI}/api/portfolio/save`, // Your new endpoint
        techProfileData, // Passing the full JSON data
        config
      );

      dispatch({
        type: TECH_PROFILE_PUBLISH_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TECH_PROFILE_PUBLISH_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const techProfileUsernameCheckAction =
  (username) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TECH_PROFILE_USERNAME_CHECK_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      // Using PUT to update/publish the profile. You could also use POST.
      const { data } = await axios.post(
        `${URI}/api/portfolio/check-username`, // Your new endpoint
        { username }, // Passing the full JSON data
        config
      );

      dispatch({
        type: TECH_PROFILE_USERNAME_CHECK_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TECH_PROFILE_USERNAME_CHECK_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const techProfileUsernameCheckResetAction = () => (dispatch) => {
  dispatch({
    type: TECH_PROFILE_USERNAME_CHECK_RESET,
  });
};

export const techProfileGetDataByUsernameAction =
  (username) => async (dispatch) => {
    try {
      dispatch({
        type: TECH_PROFILE_GET_DATA_BY_USERNAME_REQUEST,
      });

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.get(`${URI}/api/portfolio/${username}`);

      dispatch({
        type: TECH_PROFILE_GET_DATA_BY_USERNAME_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TECH_PROFILE_GET_DATA_BY_USERNAME_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const techProfileGetUserPreviousDataAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: TECH_PROFILE_GET_PREVIOUS_DATA_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      // Using PUT to update/publish the profile. You could also use POST.
      const { data } = await axios.get(
        `${URI}/api/portfolio/previous-data`, // Your new endpoint
        config
      );

      dispatch({
        type: TECH_PROFILE_GET_PREVIOUS_DATA_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TECH_PROFILE_GET_PREVIOUS_DATA_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const techProfileResetUserPreviousDataAction = () => (dispatch) => {
  dispatch({
    type: TECH_PROFILE_GET_PREVIOUS_DATA_RESET,
  });
};
